module.exports = __webpack_public_path__ + "img/digital-signage-PCS-logo.bc49ffe5.png";